import React from 'react';

/**
 * Deliverables — "What's Included" grid.
 * Props:
 *   deliverables – array of { name, icon }
 *   theme – theme object from SERVICE_THEMES
 */
export default function Deliverables({ deliverables, theme }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {deliverables.map((item, idx) => {
        const Icon = item.icon;
        return (
          <div
            key={idx}
            className="flex items-center gap-3.5 p-4 rounded-xl transition-all duration-200 hover:scale-[1.01] hover:shadow-sm"
            style={{ backgroundColor: theme.lightBg }}
          >
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
              style={{ backgroundColor: `${theme.accent}18` }}
            >
              <Icon className="w-4.5 h-4.5" style={{ color: theme.accent }} />
            </div>
            <span className="text-sm font-medium text-gray-700 leading-snug">
              {item.name}
            </span>
          </div>
        );
      })}
    </div>
  );
}
